(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldReadonly', activityFieldReadonly);

    function activityFieldReadonly() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                model: '=ngModel',
            },
            require: 'ngModel',
            templateUrl: 'common/app/components/activities/activity-input/fields/readonly',
        };
    }
})();
